import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconBadge } from './ui';

// "Growing across Africa" (WU-RECV): where LulPay is today and where it is going. Always visible, once.
const ExpansionStrip: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="receive-expansion">
      <IconBadge name="globe" className="receive-expansion__icon" />
      <div className="receive-expansion__text">
        <p className="receive-expansion__eyebrow">{t('receive.expansion.eyebrow')}</p>
        <h3 className="receive-expansion__title">{t('receive.expansion.title')}</h3>
        <p className="receive-expansion__body">{t('receive.expansion.body')}</p>
      </div>
      <ul className="receive-expansion__statuses">
        <li className="receive-expansion__status receive-expansion__status--now">
          <span className="receive-expansion__dot" aria-hidden="true" />
          {t('receive.expansion.now')}
        </li>
        <li className="receive-expansion__status receive-expansion__status--soon">
          <span className="receive-expansion__dot" aria-hidden="true" />
          {t('receive.expansion.soon')}
        </li>
      </ul>
    </div>
  );
};

export default ExpansionStrip;
